var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderConstructionIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 124,
    viewBox: "0 0 230 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#b2b5b7}.cls-4{fill:#8898aa}.cls-5{fill:#fb9905}.cls-6{fill:#fff}.cls-8{fill:#232321}.cls-9{fill:rgba(0,0,0,.2)}.cls-10{fill:#b3b3b3}.cls-11{fill:#9a9896}.cls-12{fill:#ffbf5e}.cls-13{fill:#a56300}.cls-14{fill:#d98400}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UnderConstruction-Illustration",
    opacity: 0.7,
    transform: "translate(0 -.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    fill: "#172b4d",
    d: "M84.081 81.29C94.825 83.74 72.62 87.77 55.437 84c-20.521-4.49-42.8-4.3-45.438-.46s31.893 3.72 40.125 6.59c7.465 2.6-23.92 4.59-16.893 10 8.97 6.83 58.374 6 70.195 2 26.441-9 53.71-3 63.786-1.13 21.189 4 73.384-.91 34.385-7.2-19.345-3.12-15.947-6.28-1-8.09 24.3-3 2.272-7.81-14.95-6.31-4.575.39-8.332 1.68-17.192 2.1-7.734.37-16.584-.43-17.731-1.67-2.86-3.12 23.92-5.44 21.488-8.15-3.578-4-37.235-4.69-39.747-.58-2.731 4.49-13.555 6.38-30.737 4.88-12.9-1.12-23.421-.56-27.279 1.36s5.317 2.97 9.632 3.95z",
    transform: "translate(0 -.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1839",
    d: "M0 0H7.81V96.311H0z",
    className: "cls-3",
    transform: "translate(40.315 9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1840",
    d: "M0 0H7.81V96.311H0z",
    className: "cls-3",
    transform: "translate(177.309 9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1841",
    d: "M0 0H19.07V4.43H0z",
    className: "cls-4",
    transform: "translate(34.697 102.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1842",
    d: "M0 0H19.07V4.43H0z",
    className: "cls-4",
    transform: "translate(171.668 102.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1843",
    d: "M0 0H169.47V21.21H0z",
    className: "cls-5",
    transform: "translate(27.98 9.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1844",
    d: "M0 0H169.47V21.21H0z",
    className: "cls-5",
    transform: "translate(27.98 43.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    d: "M172.24 9.9l5.88 10.61 5.87 10.6h12.93l-5.87-10.6-5.89-10.61z",
    className: "cls-6",
    transform: "translate(-.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    d: "M173.66 44.04l5.81 10.61 5.81 10.6h12.76l-5.81-10.6-5.81-10.61z",
    className: "cls-6",
    transform: "translate(-.69 -.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    d: "M133.95 9.9l6.61 10.61 6.59 10.6h14.51l-6.6-10.6-6.6-10.61z",
    className: "cls-6",
    transform: "translate(-.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    d: "M137.36 44.04l6.06 10.61 6.05 10.6h13.31l-6.06-10.6-6.06-10.61z",
    className: "cls-6",
    transform: "translate(-.462 -.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    d: "M100.23 9.9l6.24 10.61 6.22 10.6h13.7l-6.22-10.6-6.23-10.61z",
    className: "cls-6",
    transform: "translate(-.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    d: "M103.5 44.04l5.72 10.61 5.72 10.6h12.58l-5.72-10.6-5.72-10.61z",
    className: "cls-6",
    transform: "translate(-.346 -.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    d: "M66.84 9.9l5.79 10.61 5.77 10.6h12.73l-5.78-10.6L79.56 9.9z",
    className: "cls-6",
    transform: "translate(-.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    d: "M66.98 44.04L73 54.65l6.02 10.6h13.23l-6.02-10.6-6.03-10.61z",
    className: "cls-6",
    transform: "translate(-.225 -.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    d: "M31.91 44.04l6.03 10.61 6.02 10.6h13.23l-6.02-10.6-6.03-10.61z",
    className: "cls-6",
    transform: "translate(0 -.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    d: "M32.58 9.9l5.55 10.61 5.53 10.6h12.2l-5.54-10.6L44.78 9.9z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    fill: "#f6cc50",
    d: "M152 59L118.76 3.51a7.17 7.17 0 0 0-12.33 0L73.24 59a7.19 7.19 0 0 0 6.17 10.88h66.38A7.19 7.19 0 0 0 152 59z",
    transform: "translate(-.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    d: "M145.22 66.36H80a4.47 4.47 0 0 1-3.83-6.76l32.6-54.51a4.46 4.46 0 0 1 7.66 0l32.62 54.51a4.47 4.47 0 0 1-3.83 6.76zM112.6 5.59a1.76 1.76 0 0 0-1.54.87L78.43 61A1.81 1.81 0 0 0 80 63.7h65.25a1.8 1.8 0 0 0 1.57-.92 1.78 1.78 0 0 0 0-1.81L114.14 6.46a1.76 1.76 0 0 0-1.54-.87z",
    className: "cls-8",
    transform: "translate(-.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    d: "M112.29 16.88a3.47 3.47 0 0 0-3.06 3.68l1.51 25.66a1.86 1.86 0 0 0 3.72 0L116 20.41a3.37 3.37 0 0 0-3.71-3.53z",
    className: "cls-8",
    transform: "translate(-.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    d: "M116 54.65a3.38 3.38 0 1 1-3.38-3.38 3.38 3.38 0 0 1 3.38 3.38z",
    className: "cls-8",
    transform: "translate(-.337 -.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    d: "M28.64 111.06c0 .85-6.41 1.54-14.32 1.54S0 111.91 0 111.06s6.41-1.55 14.32-1.55 14.32.7 14.32 1.55z",
    className: "cls-9",
    transform: "translate(0 -.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1845",
    d: "M0 0H16.81V4.62H0z",
    className: "cls-10",
    transform: "rotate(-68.53 62.935 14.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    d: "M27.71 58.11l8 3.14c11.37 4.39 13.09 7.53 13.82 5.55.94-2.53 2.64-8.26-10.56-13.7L31 50a1.14 1.14 0 0 0-1.49.64l-2.42 6a1.15 1.15 0 0 0 .62 1.47z",
    className: "cls-11",
    transform: "translate(0 -.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1846",
    d: "M0 0H6.62V1.4H0z",
    className: "cls-10",
    transform: "rotate(-68.16 54.248 8.985)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1847",
    width: 47.02,
    height: 7.32,
    className: "cls-12",
    rx: 3.38,
    transform: "rotate(-68.6 84.3 48.607)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1848",
    width: 4.86,
    height: 12.53,
    className: "cls-13",
    rx: 2.24,
    transform: "rotate(-68.6 61.353 18.957)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1849",
    width: 10.92,
    height: 4.62,
    className: "cls-11",
    rx: 2.13,
    transform: "rotate(-68.6 51.85 12.954)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1850",
    width: 36.52,
    height: 0.63,
    className: "cls-14",
    rx: 0.29,
    transform: "rotate(-68.61 83.982 46.103)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1851",
    width: 36.52,
    height: 0.63,
    className: "cls-14",
    rx: 0.29,
    transform: "rotate(-68.61 85.476 45.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1852",
    width: 36.52,
    height: 0.63,
    className: "cls-14",
    rx: 0.29,
    transform: "rotate(-68.57 87.028 44.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    d: "M230.69 123c0 .83-6.29 1.51-14 1.51s-14-.68-14-1.51 6.29-1.52 14-1.52 14 .64 14 1.52z",
    className: "cls-9",
    transform: "translate(-.69 -.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1853",
    fill: "#6e6e6e",
    d: "M0 0H5.57V9.76H0z",
    transform: "rotate(-37.09 233.69 -247.872)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1854",
    width: 6.81,
    height: 41.86,
    className: "cls-12",
    rx: 2.28,
    transform: "rotate(-37.06 176.368 -227.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1855",
    width: 15.18,
    height: 5.88,
    className: "cls-13",
    rx: 2.58,
    transform: "rotate(-37.09 233.146 -239.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    fill: "#c2c2c2",
    d: "M192.08 105.74l25.27-19.1 9.82 13c2.1 2.78 1.14 18.44-3.36 21.83s-19.51.46-22.18-3.08z",
    transform: "translate(-.69 -.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    fill: "#a1a1a1",
    d: "M195.46 103.18l-3.38 2.56 9.55 12.63c2.67 3.54 17.69 6.48 22.18 3.08 2.59-2 4-8 4.34-13.23-10.89-1.13-21.82-3.22-32.69-5.04z",
    transform: "translate(-.69 -.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    d: "M179.44 59.33a.29.29 0 0 1 .4 0l19.39 25.89a.27.27 0 0 1-.09.38.28.28 0 0 1-.39 0l-19.4-25.88a.3.3 0 0 1 .09-.39z",
    className: "cls-14",
    transform: "translate(-.69 -.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    d: "M177.86 60.52a.28.28 0 0 1 .39 0l19.4 25.89a.28.28 0 0 1-.1.38.29.29 0 0 1-.39 0l-19.4-25.89a.3.3 0 0 1 .1-.38z",
    className: "cls-14",
    transform: "translate(-.69 -.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    d: "M176.26 61.73a.28.28 0 0 1 .39 0l19.4 25.89a.28.28 0 0 1-.1.38.28.28 0 0 1-.39 0l-19.4-25.89a.28.28 0 0 1 .1-.38z",
    className: "cls-14",
    transform: "translate(-.69 -.32)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstructionIllustration);
export default __webpack_public_path__ + "static/media/UnderConstruction-Illustration.a683b5ab8dc0991de20410e38034f328.svg";
export { ForwardRef as ReactComponent };